(() => {
  const SELECTORS = {
    section: '.faq',
    item: '.faq__item',
    question: '.faq__question'
  };

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const getDuration = (element) => {
    const value = getComputedStyle(element).getPropertyValue('--duration-default').trim();

    if (value.endsWith('ms')) return Number.parseFloat(value);
    if (value.endsWith('s')) return Number.parseFloat(value) * 1000;

    return 250;
  };

  const getEasing = (element) => {
    return getComputedStyle(element).getPropertyValue('--ease-out').trim() || 'cubic-bezier(0.22, 1, 0.36, 1)';
  };

  const animateItem = (item, shouldOpen) => {
    if (prefersReducedMotion.matches) {
      item.open = shouldOpen;
      return;
    }

    if (typeof item.animate !== 'function') {
      item.open = shouldOpen;
      return;
    }

    if (item.dataset.animating === 'true') return;

    const startHeight = `${item.offsetHeight}px`;
    item.dataset.animating = 'true';

    if (shouldOpen) {
      delete item.dataset.closing;
      item.open = true;
    } else {
      item.dataset.closing = 'true';
    }

    const endHeight = `${item.scrollHeight}px`;
    const animation = item.animate(
      {
        height: shouldOpen ? [startHeight, endHeight] : [startHeight, `${item.querySelector(SELECTORS.question).offsetHeight}px`]
      },
      {
        duration: getDuration(item),
        easing: getEasing(item)
      }
    );

    item.style.overflow = 'hidden';

    animation.onfinish = () => {
      if (!shouldOpen) item.open = false;
      item.style.height = '';
      item.style.overflow = '';
      delete item.dataset.closing;
      delete item.dataset.animating;
    };

    animation.oncancel = () => {
      item.style.height = '';
      item.style.overflow = '';
      delete item.dataset.closing;
      delete item.dataset.animating;
    };
  };

  const initFaq = (section) => {
    section.querySelectorAll(SELECTORS.item).forEach((item) => {
      if (item.dataset.faqInitialized === 'true') return;

      const question = item.querySelector(SELECTORS.question);
      if (!question) return;

      item.dataset.faqInitialized = 'true';

      question.addEventListener('click', (event) => {
        event.preventDefault();
        animateItem(item, !item.open);
      });
    });
  };

  document.querySelectorAll(SELECTORS.section).forEach(initFaq);

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector(SELECTORS.section);
    if (section) initFaq(section);
  });
})();
